import { z } from "zod";
import { common } from "../common";
import { kakaoMessageDetailsSchema } from "../shared/kakaoMessageDetailsSchema";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const kakaoMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("kakao"),
  link_template_ids: z.array(z.union([z.string(), common.objectId])).nullable(),
  messages: z.array(kakaoMessageDetailsSchema).optional(),
  messaging_service_id: z.union([z.string(), common.objectId]).optional(),
});
